import React, { useEffect } from 'react'
import { useState } from 'react'
import { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import { CircularProgress, Snackbar } from '@material-ui/core';
import ENDPOINT from '../../context/EndPoint'
import { useParams } from 'react-router-dom';
import axios from 'axios';
const AddNewCourse = ({id,batchid,course_id}) => {



const {user} =  useContext(AuthContext)

const params = useParams();

const [courseid,setcourseid] = useState(null)







useEffect(()=>{


},[])




const [ctitle,setctitle] = useState(null);
const [cduration,setcduration] = useState(null);
const [cdescription,setcdescription] = useState(null);
const [crating,setcrating]=useState(null);
const [cratings,setcratings] = useState(null)
const [cprice,setcprice] = useState(null);
const [cutoff,setcutoff] = useState(null);
const [offerends,setofferends] = useState(null)
const [seatsleft,setseatsleft] = useState(null)
const [nextbatch,setnextbatch] = useState(null)
const [coursedata,setcoursedata] = useState(null)
const [courseurl,setcourseurl] = useState(null)
const [cstatus,setcstatus] = useState("actve")
          const [promourl,setpromourl] = useState(null);
          const [coverurl,setcoverurl] = useState(null)
const [mode,setmode] = useState("live")

      const [status,setstatus]= useState("pending")
const [addstatus,setaddstatus] = useState(false)
      const [snackbar,setsnackbar] = useState(false);
      const [snackbarMessage,setsnackbarMessage] = useState(null)
      
      

      const updateCourse = async (e)=>{
      e.preventDefault();
        const formData = new FormData();
        
        
        //formData.append('whyus',document.getElementById('whyus').value)
        
        formData.append('session',user.SessionId);
        formData.append('course_id',courseid);
          formData.append('status',cstatus);
          formData.append('course_title',ctitle);
          formData.append('description',cdescription);
          formData.append('course_price',cprice);
          formData.append('cutoff_price',cutoff);
          formData.append('offer_ends',offerends);
          formData.append('seats_left',seatsleft);
          formData.append('next_batch',nextbatch);
          formData.append('rating',crating);
          formData.append('ratings',cratings);
          formData.append('duration',cduration);
          formData.append('course_url',courseurl);
          formData.append('mode',mode);
         
       
          formData.append('promo_url',promourl);
   
        const res = await axios.post(ENDPOINT+"admin-add-course.php", formData,{
          
        
        headers: {
                'content-type': 'multipart/form-data'
            }
        });
        if(res){
          // console.log("posted result "+ JSON.stringify(res))
         if(res.data.status==="success"){
           setsnackbarMessage("Course Added")
         setsnackbar(true)
         }
         else{
          setsnackbarMessage("Something went wrong !")
          setsnackbar(true)
         }
        }
        }
        
          




     
          const options = ['Option 1', 'Option 2'];
          
        
            const [value, setValue] = React.useState(options[0]);
            const [inputValue, setInputValue] = React.useState('');
          
   



      



            return (
              <div className="container py-4">
            
                <div className="row justify-content-center">
            
                  <div className="col-lg-11">
            
                    <div className="card border-0 shadow-lg rounded-4">
            
                      <div className="card-body p-4">
            
                        <h3 className="fw-bold text-primary mb-4">
                          Add New Course
                        </h3>
            
                        <form onSubmit={updateCourse}>
            
                          {/* ROW 1 */}
                          <div className="row g-3">
            
                            <div className="col-md-4">
                              <label className="form-label fw-semibold">
                                Course ID
                              </label>
            
                              <input
                                type="text"
                                className="form-control"
                                value={courseid}
                                onChange={(e) => setcourseid(e.target.value)}
                              />
                            </div>
            
                            <div className="col-md-5">
                              <label className="form-label fw-semibold">
                                Course Title
                              </label>
            
                              <input
                                type="text"
                                className="form-control"
                                value={ctitle}
                                onChange={(e) => setctitle(e.target.value)}
                              />
                            </div>
            
                            <div className="col-md-3">
                              <label className="form-label fw-semibold">
                                Status
                              </label>
            
                              <select
                                className="form-select"
                                value={cstatus}
                                onChange={(e) => setcstatus(e.target.value)}
                              >
                                <option value="active">Active</option>
                                <option value="paused">Paused</option>
                                <option value="completed">Completed</option>
                              </select>
                            </div>
            
                          </div>
            
                          {/* DESCRIPTION */}
                          <div className="row g-3 mt-1">
            
                            <div className="col-12">
                              <label className="form-label fw-semibold">
                                Description
                              </label>
            
                              <textarea
                                className="form-control"
                                rows="4"
                                value={cdescription}
                                onChange={(e) => setcdescription(e.target.value)}
                              />
                            </div>
            
                          </div>
            
                          {/* URLS */}
                          <div className="row g-3 mt-1">
            
                            <div className="col-md-4">
                              <label className="form-label fw-semibold">
                                Course URL
                              </label>
            
                              <input
                                type="text"
                                className="form-control"
                                value={courseurl}
                                onChange={(e) => setcourseurl(e.target.value)}
                              />
                            </div>
            
                            <div className="col-md-4">
                              <label className="form-label fw-semibold">
                                Promo URL
                              </label>
            
                              <input
                                type="text"
                                className="form-control"
                                value={promourl}
                                onChange={(e) => setpromourl(e.target.value)}
                              />
                            </div>
            
                            <div className="col-md-4">
                              <label className="form-label fw-semibold">
                                Cover Image URL
                              </label>
            
                              <input
                                type="text"
                                className="form-control"
                                value={coverurl}
                                onChange={(e) => setcoverurl(e.target.value)}
                              />
                            </div>
            
                          </div>
            
                          {/* PRICING */}
                          <div className="row g-3 mt-1">
            
                            <div className="col-md-3">
                              <label className="form-label fw-semibold">
                                Actual Price
                              </label>
            
                              <input
                                type="number"
                                className="form-control"
                                value={cprice}
                                onChange={(e) => setcprice(parseInt(e.target.value))}
                              />
                            </div>
            
                            <div className="col-md-3">
                              <label className="form-label fw-semibold">
                                Cutoff Price
                              </label>
            
                              <input
                                type="number"
                                className="form-control"
                                value={cutoff}
                                onChange={(e) => setcutoff(parseInt(e.target.value))}
                              />
                            </div>
            
                            <div className="col-md-3">
                              <label className="form-label fw-semibold">
                                Offer Ends
                              </label>
            
                              <input
                                type="date"
                                className="form-control"
                                value={offerends}
                                onChange={(e) => setofferends(e.target.value)}
                              />
                            </div>
            
                            <div className="col-md-3">
                              <label className="form-label fw-semibold">
                                Seats Left
                              </label>
            
                              <input
                                type="text"
                                className="form-control"
                                value={seatsleft}
                                onChange={(e) => setseatsleft(e.target.value)}
                              />
                            </div>
            
                          </div>
            
                          {/* BATCH */}
                          <div className="row g-3 mt-1">
            
                            <div className="col-md-3">
                              <label className="form-label fw-semibold">
                                Next Batch
                              </label>
            
                              <input
                                type="date"
                                className="form-control"
                                value={nextbatch}
                                onChange={(e) => setnextbatch(e.target.value)}
                              />
                            </div>
            
                            <div className="col-md-3">
                              <label className="form-label fw-semibold">
                                Rating
                              </label>
            
                              <input
                                type="text"
                                className="form-control"
                                value={crating}
                                onChange={(e) => setcrating(e.target.value)}
                              />
                            </div>
            
                            <div className="col-md-3">
                              <label className="form-label fw-semibold">
                                Ratings Count
                              </label>
            
                              <input
                                type="text"
                                className="form-control"
                                value={cratings}
                                onChange={(e) => setcratings(e.target.value)}
                              />
                            </div>
            
                            <div className="col-md-3">
                              <label className="form-label fw-semibold">
                                Duration
                              </label>
            
                              <input
                                type="text"
                                className="form-control"
                                value={cduration}
                                onChange={(e) => setcduration(e.target.value)}
                              />
                            </div>
            
                          </div>
            
                          {/* BUTTON */}
                          <div className="mt-4">
            
                            <button
                              type="submit"
                              className="btn btn-primary w-100 py-2 fw-bold"
                            >
                              {addstatus ? (
                                <CircularProgress
                                  size={20}
                                  className="text-white me-2"
                                />
                              ) : null}
            
                              Save Course
                            </button>
            
                          </div>
            
                        </form>
            
                      </div>
            
                    </div>
            
                  </div>
            
                </div>
            
                <Snackbar
                  open={snackbar}
                  autoHideDuration={6000}
                  onClose={() => setsnackbar(false)}
                  message={snackbarMessage}
                />
            
              </div>
            )
}

export default AddNewCourse
